import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function downloadReportApi(formData) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.reportApi,
    method: "post",
    payload: formData
  });
}